import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import {CTAButton} from '../../StyledComponents';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faArrowRight from '@fortawesome/fontawesome-free-solid/faArrowRight';
import ReactTooltip from 'react-tooltip'

const ArrowRight = styled(FontAwesomeIcon)`
  margin-left:10px;
`;


const StyledReactTooltip = styled(ReactTooltip)`
  color:#555 !important;
  background-color:#fff !important;
  opacity: 1 !important;
  font-size:10px;



  &.__react_component_tooltip.type-dark.place-top {
    &:after {
      border-top-color: #fff;
    }
  }
`;

class TooltipButton extends Component {
  render() {
    return(
      <CTAButton
        //onClick={() => this.props.history.push('/recommendations')}
        onClick={() => this.props.history.push(this.props.path)}
        key="ctabutton"
        className="hidden-xs"
        data-for={"tip"}
        data-tip="a"
      >
        <span>{this.props.label}</span>
        <ArrowRight icon={faArrowRight} />

        <StyledReactTooltip id={"tip"} effect="solid">
          {this.props.tooltip}
        </StyledReactTooltip>

      </CTAButton>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    data: state.data
  };
}

export default withRouter(connect(mapStateToProps, { })(TooltipButton));



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/TooltipButton.js